module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boxMenu"
  }, [_c('div', [_c('div', {
    ref: "platform",
    staticClass: "Rectangle ",
    on: {
      "click": function($event) {
        _vm.boxFunc(0, $event)
      }
    }
  }, [_c('h1', {
    staticClass: "developer_documataion_menu_overview "
  }, [_vm._v(_vm._s(_vm.$t('introductionPlatform')))])]), _vm._v(" "), _c('ul', {
    staticClass: "displayMenu ulHideContent"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.isSideBarShow))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "Rectangle",
    on: {
      "click": function($event) {
        _vm.boxFunc(1, $event)
      }
    }
  }, [_c('h1', {
    staticClass: "developer_documataion_menu_overview "
  }, [_vm._v(_vm._s(_vm.$t('developmentProcess')))])]), _vm._v(" "), _c('ul', {
    staticClass: "displayMenu ulHideContent"
  }, [_c('li', {
    ref: "start",
    on: {
      "mouseenter": function($event) {
        _vm.mouseenterLiFunc('0')
      },
      "mouseleave": function($event) {
        _vm.mouseleaveLiFunc()
      },
      "click": function($event) {
        _vm.boxFuncLi('start', $event)
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('getStarted')))]), _vm._v(" "), _c('span', {
    staticClass: "line_5",
    class: {
      borderSpanClass: _vm.isLiHoverEnter === '0'
    },
    style: (this.$store.state.isSideBarShow === 'start' ? ' background-color: #00e0da;opacity: 1; ' : '')
  })]), _vm._v(" "), _c('li', {
    ref: "sdk",
    on: {
      "mouseenter": function($event) {
        _vm.mouseenterLiFunc('1')
      },
      "mouseleave": function($event) {
        _vm.mouseleaveLiFunc()
      },
      "click": function($event) {
        _vm.boxFuncLi('sdk', $event)
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('instructionsSdk')))]), _vm._v(" "), _c('span', {
    staticClass: "line_5",
    class: {
      borderSpanClass: _vm.isLiHoverEnter === '1'
    },
    style: (this.$store.state.isSideBarShow === 'sdk' ? ' background-color: #00e0da;opacity: 1; ' : '')
  })]), _vm._v(" "), _c('li', {
    ref: "motion",
    on: {
      "mouseenter": function($event) {
        _vm.mouseenterLiFunc('2')
      },
      "mouseleave": function($event) {
        _vm.mouseleaveLiFunc()
      },
      "click": function($event) {
        _vm.boxFuncLi('motion', $event)
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('actionListDescription')))]), _vm._v(" "), _c('span', {
    staticClass: "line_5",
    class: {
      borderSpanClass: _vm.isLiHoverEnter === '2'
    },
    style: (this.$store.state.isSideBarShow === 'motion' ? '  background-color: #00e0da;opacity: 1;  ' : '')
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e01fd2d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 1493
// module chunks = 1